import React from "react";
export default () => {
  return (
    <li>
      <span className="pagination-ellipsis">&hellip;</span>
    </li>
  );
};



// WEBPACK FOOTER //
// ./src/components/Pagination/PaginationEllipsis.js